module.exports = __webpack_public_path__ + "img/reset.323d25c4.png";